
export const accounts = {
  'accounts.title': 'Conti di Investimento',
  'accounts.subtitle': 'Visualizza e gestisci i tuoi conti di investimento',
  'accounts.loading': 'Caricamento conti...',
  'accounts.error': 'Errore nel caricamento dei conti',
  'accounts.noAccounts': 'Nessun conto di investimento trovato',
  'accounts.accountNumber': 'Numero Conto',
  'accounts.balance': 'Saldo',
  'accounts.accountShare': 'Quota Conto',
  'accounts.accountOpen': 'Conto Aperto',
  'accounts.broker': 'Broker',
  'accounts.active': 'Attivo',
  'accounts.inactive': 'Inattivo',
  'accounts.pending': 'In Sospeso',
  'accounts.closed': 'Chiuso',
  
  // Transactions section
  'accounts.transactions.title': 'Transazioni Conto',
  'accounts.transactions.subtitle': 'Visualizza la cronologia dei tuoi depositi e prelievi',
  'accounts.transactions.loading': 'Caricamento transazioni...',
  'accounts.transactions.error': 'Errore nel caricamento delle transazioni',
  'accounts.transactions.noTransactions': 'Nessuna transazione trovata',
  'accounts.transactions.export': 'Esporta CSV',
  'accounts.transactions.loadMore': 'Carica Altro',
  
  // Table columns
  'accounts.transactions.table.account': 'Conto',
  'accounts.transactions.table.date': 'Data',
  'accounts.transactions.table.amount': 'Importo',
  'accounts.transactions.table.operation': 'Operazione',
  
  // Operations
  'accounts.transactions.deposit': 'Deposito',
  'accounts.transactions.withdrawal': 'Prelievo',
  
  // Filters
  'accounts.transactions.filters.account': 'Filtra per Conto',
  'accounts.transactions.filters.operation': 'Filtra per Operazione',
  'accounts.transactions.filters.dateFrom': 'Da Data',
  'accounts.transactions.filters.dateTo': 'A Data',
  'accounts.transactions.filters.apply': 'Applica Filtri',
  'accounts.transactions.filters.reset': 'Ripristina Filtri',
  'accounts.transactions.filters.allAccounts': 'Tutti i Conti',
  'accounts.transactions.filters.allOperations': 'Tutte le Operazioni',
  
  // Add Account section
  'accounts.addAccount.title': 'Aggiungi Conto di Investimento PAMM',
  'accounts.addAccount.subtitle': 'Fornisci l\'ID del Conto PAMM e l\'Email Associata',
  'accounts.addAccount.pammAccount': 'Conto PAMM',
  'accounts.addAccount.associatedEmail': 'Email Associata',
  'accounts.addAccount.validateAccount': 'Valida Conto',
  'accounts.addAccount.instructionsTitle': 'Segui le istruzioni sottostanti per trovare il tuo Conto PAMM',
  'accounts.addAccount.step1.title': 'Accesso al tuo conto PAMM utilizzando le credenziali ricevute nella tua email',
  'accounts.addAccount.step1.substep1': 'Cerca un\'email con oggetto: "RADEX MARKETS - Successfully joined PAMM of the money manager - The Club Funding Pro"',
  'accounts.addAccount.step1.substep2': 'Apri il link fornito nell\'email: https://pamm.radexmarkets.com/app/auth/investor',
  'accounts.addAccount.step2.title': 'Ottieni il tuo ID Conto PAMM dal Portale Radex Markets a cui ti sei appena collegato',
  'accounts.addAccount.step2.description': 'L\'ID del Conto PAMM è evidenziato nell\'immagine sottostante',
  'accounts.addAccount.validation.pammAccountRequired': 'Il Conto PAMM è obbligatorio',
  'accounts.addAccount.validation.pammAccountInvalid': 'Il Conto PAMM deve essere un numero positivo',
  'accounts.addAccount.validation.emailRequired': 'L\'Email Associata è obbligatoria',
  'accounts.addAccount.validation.emailInvalid': 'Inserisci un indirizzo email valido',
  'accounts.addAccount.success': 'Conto validato con successo',
  'accounts.addAccount.error': 'Errore nella validazione del conto',
  'accounts.addAccount.validating': 'Validazione conto...',
  'accounts.addAccount.successDescription': 'Il tuo conto di investimento è stato aggiunto con successo.',
  
  // Error messages
  'accounts.addAccount.messages.success': 'Conto validato e aggiunto con successo',
  'accounts.addAccount.messages.missing_fields': 'Si prega di compilare tutti i campi richiesti',
  'accounts.addAccount.messages.account_exists': 'Questo conto di investimento è già registrato',
  'accounts.addAccount.messages.account_already_registered': 'Questo conto non può essere registrato',
  'accounts.addAccount.messages.account_not_active': 'Il conto non è attivo. Si prega di assicurarsi che il conto sia attivo prima della validazione',
  'accounts.addAccount.messages.account_validation_failed': 'Validazione del conto fallita. Si prega di verificare il numero del conto e l\'indirizzo email',
  'accounts.addAccount.messages.insert_failed': 'Errore nella registrazione del conto. Si prega di riprovare',
  'accounts.addAccount.messages.server_error': 'Si è verificato un errore. Si prega di riprovare più tardi',
  'accounts.addAccount.messages.systemError': 'L\'operazione è fallita, riprova più tardi o contatta l\'Assistenza Clienti',
  
  // Placeholders
  'accounts.addAccount.placeholders.pammAccount': 'Inserisci ID Conto PAMM',
  'accounts.addAccount.placeholders.associatedEmail': 'Inserisci Email Associata',
  
  // General
  'accounts.notAvailable': 'Non disponibile',
  'accounts.addNewAccount': 'Aggiungi Nuovo Conto',
};
